import { Svg } from 'components/svg'

export const IconPause = () => (
  <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <rect
      width="5"
      height="16"
      transform="translate(5 4)"
      fill="currentColor"
    />
    <rect
      width="5"
      height="16"
      transform="translate(14 4)"
      fill="currentColor"
    />
  </Svg>
)
